
// export const myMutation = ( state ) => {

// }

export const setUsers = ( state, users ) => {
    state.users = users
}

export const activateUser = ( state, user ) => {
    state.users.filter(u => u.id == user.id)[0].estado = 'Activo'
}

export const deactivateUser = ( state, user ) => {
    state.users.filter(u => u.id == user.id)[0].estado = 'Inactivo'
}

export const setPrograms = ( state, programs ) => {
    state.programs = programs
}

export const setHfs = ( state, hfs ) => {
    state.hfs = hfs
}

export const setCurrentUser = ( state, currentUser ) => {
    state.currentUser = currentUser
}

export const setTeachers = ( state, teachers ) => {
    state.teachers = teachers
}

export const setUsersStatistics = ( state, staticts ) => {
    state.usersStaticts = staticts
}